import { rem } from "@mantine/core";

type Props = {
  size?: number | string;
  stroke?: number;
};

export function IconColumns5({ size = 24, stroke = 2 }: Props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={rem(size)}
      height={rem(size)}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={stroke}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M3 4a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v16a1 1 0 0 1 -1 1h-16a1 1 0 0 1 -1 -1v-16" />
      <path d="M6.6 3v18" />
      <path d="M10.2 3v18" />
      <path d="M13.8 3v18" />
      <path d="M17.4 3v18" />
    </svg>
  );
}
